import PropTypes from "prop-types"
import React from "react"

import IconSvg from "@atoms/IconSvg/IconSvg"
import checkIcon from "@images/svg/check-icon.svg"

import styles from "./Checkbox.module.scss"

const Checkbox = ({ name, id, label, onCheck, className, checked }) => (
  <div className={`${styles.styledCheckbox} ${className || ""}`}>
    <input
      type="checkbox"
      className="invisible opacity-0 absolute"
      name={name}
      onChange={onCheck}
      id={id}
      checked={checked}
    />
    <label className="text-sm leading-3 flex align-center" htmlFor={id}>
      <span className="inline-flex justify-center align-center w-3.5 h-3.5 mr-2 rounded-sm ring-2 ring-black ring-inset text-white">
        <IconSvg Icon={checkIcon} widthClass="w-3" />
      </span>
      {label}
    </label>
  </div>
)

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onCheck: PropTypes.func.isRequired,
  className: PropTypes.string,
  checked: PropTypes.bool,
}

export default Checkbox
